// extracted by mini-css-extract-plugin
export var footer = "_qx-5";
export var fulfillmentInput = "_qx-0";
export var shipDateInput = "_qx-1";
export var shipmentModal = "_qx-2";
export var shipmentModalContent = "_qx-3";
export var tableContainer = "_qx-4";